export default __webpack_public_path__ + "static/media/manejecover.b5ea17b2.png";